import React from 'react';
import Header from './Header';
import CreditForm from './CreditForm';
import image from '../img/image.png';

function CreditBuilder() {
    return (
        <div className="flex relative flex-col items-center py-7 w-full rounded-3xl min-h-[1434px] max-md:max-w-full">
            <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/83c77f3f5ef232c30022ed0746b9fc4ffcad0120de6b844829147f76ee18476d?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-cover absolute inset-0 size-full" />
            <Header />
            <header id='request' className="flex relative flex-col px-10 w-full max-md:px-5 max-md:max-w-full">
                <h1 className="self-start mt-2 ml-[20%] text-9xl leading-none text-white tracking-[2.4px] max-md:mt-10 max-md:ml-2.5 max-md:text-4xl">
                    Build
                </h1>
                <h2 className="self-end mt-2 mr-[20%] text-9xl leading-none text-white tracking-[2.4px] max-md:mr-2.5 max-md:max-w-full max-md:text-4xl">
                    YOUR CREDIT
                </h2>
            </header>
            <main className="relative mt-8 w-full max-md:mt-10 max-md:max-w-full">
                <div className="flex gap-5 max-md:flex-col">
                    <div className="flex flex-col w-[25%] mr-[10%] max-md:ml-0 max-md:w-full">
                        <div className="flex relative flex-col w-full text-sm font-medium tracking-widest leading-none text-black uppercase max-md:mt-10">
                            <img
                                loading="lazy"
                                src={image}
                                alt="Request Microloan"
                                className="object-contain z-10 self-end"
                            />
                        </div>
                    </div>
                    <CreditForm />
                </div>
            </main>
        </div>
    );
}

export default CreditBuilder;